/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Show_MiniappInputs */

const vi_shop_show_miniapp = /** @type {(inputs: Shop_Show_MiniappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiện Mini App`)
};

/**

* @param {Shop_Show_MiniappInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_show_miniapp = /** @type {((inputs?: Shop_Show_MiniappInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Show_MiniappInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_show_miniapp(inputs)
});